import EventEmit from '../utils/EventEmit';

const eventEmit = new EventEmit();

export function useEventEmit() {
  return eventEmit;
}
